// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"8b59a788","667":"40f6caab"}[chunkId] + ".chunk.js";
};